import React, { useEffect } from "react";

interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export default function LegalModal({ open, onClose, title, children }: LegalModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl max-w-lg w-full mx-4 max-h-[80vh] flex flex-col shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 pt-6 pb-3 border-b border-gray-100">
          <h2 className="font-semibold text-gray-900 text-lg">{title}</h2>
        </div>
        <div className="overflow-y-auto flex-1 px-6 py-4 text-sm text-gray-700 leading-relaxed">
          {children}
        </div>
        <div className="px-6 py-4 border-t border-gray-100 flex justify-end">
          <button
            onClick={onClose}
            className="bg-[#02075d] text-white rounded-lg px-5 py-2 text-sm hover:bg-[#02075d]/90 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
